import { Collapse } from 'antd';
import breakpoints from 'constants/breakpoints';
import styled from 'styled-components';

export const AvatarContainerStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const TransactionFormContainerStyled = styled.div`
  padding: 0 32px;
`;

export const CollapseStyled = styled(Collapse)`
  margin-left: 16px;
  margin-right: 16px;
  & .anticon.anticon-right.ant-collapse-arrow {
    padding: 0;
    top: 50%;
    transform: translateY(-50%);
  }
  & .ant-collapse-content-box {
    padding: 20px;
  }
`;
// padding: 10px 25px 25px;

export const InputsContainerStyled = styled.div`
  width: 420px;
  max-width: 100%;
  @media (min-width: ${breakpoints.lg}) {
    width: 650px;
    max-width: 70%;
  }
`;

export const IconStyled = styled.i`
  &::before {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

export const TextOnlyButtonStyled = styled.button<{ $color?: string }>`
  border: none;
  background: transparent;
  color: ${({ $color }) => $color || '#038fde'};
  font-size: 14px;
  padding: 0;
  cursor: pointer;
`;

export const TextOnlyStyled = styled.span<{ $color?: string; $alignRight?: boolean }>`
  border: none;
  display: inline-block;
  background: transparent;
  color: ${({ $color }) => $color || '#038fde'};
  font-size: 14px;
  padding: 0;
  margin: 0;
  ${({ $alignRight }) => ($alignRight ? 'text-align: right;' : '')}
`;

export const LabelStyled = styled.span`
  font-weight: 500;
  font-size: 16px;
`;

export const TransactionSectionContainerStyled = styled.div`
  padding-bottom: 1.5rem;
`;
